import Page from '@mjcloud/page';
import JsApiHelper from '@mjcloud/jsapi';

Page.info = content => JsApiHelper.showToast({ content });
